import React, { FC, useState } from 'react'
import { Avatar, Button, Dropdown, Icon, Menu, Modal, message } from 'antd'
import { Link } from 'react-router-dom'

import styles from './index.module.less'
import { useAuth } from '../../providers/AuthProvider'
import WrappedForm from './WrappedForm'

interface MenuIcon {
	type: string
}

const MenuIcon: FC<MenuIcon> = props => <Icon className={styles.icon} type={props.type} />

const User: FC = () => {
	const { user, logout, updateSelf, userHasPermission } = useAuth()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])
	const [modalOpen, setModalOpen] = useState(false)
	const openModal = () => setModalOpen(true)
	const closeModal = () => setModalOpen(false)

	const handleLogout = async () => {
		try {
			await logout()
		} catch (e) {
			message.error('Something went wrong. Please try again.')
		}
	}

	const handleEditClick = () => {
		if (!user.is_b2c) {
			return
		}

		openModal()
	}

	const canSeeUsageReport = isMondagoAdmin || user.service_providers.length > 1 || user.service_providers.some(sp => sp.hasLicenseLimit)

	const UserMenu = (
		<Menu>
			<Menu.Item key={1} className={!user.is_b2c && styles.disabled}>
				<Button type='link' onClick={handleEditClick}>
					{user.is_b2c && <MenuIcon type='edit' />}
					{user.name}
				</Button>
			</Menu.Item>
			<Menu.Divider />
			{canSeeUsageReport && (
				<Menu.Item key={2}>
					<Link to={'/license-usage-report'}>License Allocation Report</Link>
				</Menu.Item>
			)}
			{canSeeUsageReport && <Menu.Divider />}
			<Menu.Item key={3}>
				<Button onClick={handleLogout} type='link'>
					<MenuIcon type='logout' />
					Logout
				</Button>
			</Menu.Item>
		</Menu>
	)

	return (
		<>
			{user.is_b2c && (
				<Modal title='Edit User' destroyOnClose visible={modalOpen} closable onCancel={closeModal} footer={null}>
					<WrappedForm user={user} updateSelf={updateSelf} afterSave={closeModal} />
				</Modal>
			)}
			<Dropdown overlay={UserMenu} trigger={['hover']}>
				<Avatar className={styles.avatar}>
					{user.name
						.split(' ')
						.map(s => s[0].toUpperCase())
						.join('')}
				</Avatar>
			</Dropdown>
		</>
	)
}

export default User
